import React from "react";
import { Fragment } from "core/components/FragmentProvider";
import HeadingView from "common/views/heading/Heading.view";
import { ImageView } from "common/views/image/Image.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { ArticleContributor } from "../articleContributor/entities";

interface IArticleEditFragmentProps {
	articleContributor: ArticleContributor;
}

export const name: Fragment<IArticleEditFragmentProps> = {
	name: "Name",
	component: (props) => {
		return (
			<HeadingView viewKey="contributor.name">
				{props.articleContributor.contributor.name}
			</HeadingView>
		);
	},
};

export const contributorDescription: Fragment<IArticleEditFragmentProps> = {
	name: "Contributor Description",
	component: (props) => {
		return (
			<TypographyView
				viewKey="contributor.description"
				html={props.articleContributor.contributor.description}
			/>
		);
	},
};

export const avatar: Fragment<IArticleEditFragmentProps> = {
	name: "Avatar",
	component: (props) => {
		return (
			<ImageView
				viewKey="contributor.avatar"
				src={props.articleContributor.contributor.imageURL}
			/>
		);
	},
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/contributorCardFragments.tsx